import './style.scss';

import { ReactComponent as ArrowIcon } from "../../../../../../assets/icons/arrow.svg";


export default function AiSoraVideo() {
  return (
    <div className="ai-clip-animation">
      <img className="ai-clip-animation-img img-main" src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-sora-video/centered.webp`} alt="Main video result" />
      <img className="ai-clip-animation-img img-sora" src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-sora-video/sora.webp`} alt="Sora video" />
      <img className="ai-clip-animation-img img-original" src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-sora-video/product.webp`} alt="Original video" />

      <img
        className="ai-clip-animation-img img-enhanced-right"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-sora-video/enhanced-asset-right.webp`}
        alt="Enhanced right video"
      />
      <img
        className="ai-clip-animation-img img-enhanced-left"
        src={`${process.env.REACT_APP_BASENAME}/img/animations/ai-sora-video/enhanced-asset-left.webp`}
        alt="Enhanced left video"
      />

      <ArrowIcon className="ai-clip-animation-img img-arrow" />
    </div>
  );
}
